// extracted by mini-css-extract-plugin
module.exports = {"container":"colorsmenu_container__1Qmpo","title":"colorsmenu_title__1Fqop","body":"colorsmenu_body__1BVux","btn_cont":"colorsmenu_btn_cont__1BS05","btn":"colorsmenu_btn__P45f2"};